import { BUSINESS } from '@/lib/businessConfig';
import { HOME_FAQ } from '@/lib/homeFaq';

const SITE_URL = 'https://ikonomakis.gr';
const DEFAULT_IMAGE = BUSINESS.ogImage;
const REVIEWS_EL = BUSINESS.reviews.summaryEl;

export const PUBLIC_ROUTES = ['/', '/atelier', '/atelier/team', '/atelier/impact', '/services', '/press', '/gallery', '/before-after', '/contact', '/balayage-chalandri', '/hair-color-chalandri', '/keratin-treatment-chalandri', '/color-correction-chalandri', '/blonde-specialist-chalandri', '/k18-hair-treatment-chalandri', '/milbon-360-chalandri', '/face-metrics-pro-experience', '/premium-hair-salon-athens', '/best-hair-salon-athens', '/premium-hair-salon-greece', '/luxury-hair-atelier-greece', '/thodoris-ikonomakis-hair-expert', '/hair-expert-greece', '/ai-hair-consultation-greece', '/ai-hair-consultation-athens', '/haircut-based-on-face-shape', '/services/hair-color', '/services/haircuts', '/services/hair-treatments', '/services/face-metrics-pro', '/andriki-permanant-chalandri'];
export const ADMIN_ROUTE_PREFIXES = ['/admin', '/dashboard', '/editor', '/builder', '/VisualBuilder', '/SectionEditor', '/LandingPageView', '/PageEditor', '/VisualBuilder', '/SectionEditor', '/LandingPageView', '/Admin', '/Dashboard', '/components', '/pages', '/home/', '/home/SiteNav', '/home/SiteNavSimple', '/home/SiteFooter', '/home/PageHero', '/home/constants', '/home/ui', '/ui', '/constants', '/SocialImpactPage'];

export const seoConfig = {
  '/': {
    title: 'Premium Hair Salon Athens Greece | Ikonomakis Hair Atelier',
    description: 'Premium κομμωτήριο στο Χαλάνδρι από το 1995. Balayage από €150, κούρεμα από €45, AI ανάλυση προσώπου. 4.9★ από 2.199 κριτικές. Κλείσε online.',
    image: DEFAULT_IMAGE,
    type: 'website',
  },
  '/services': {
    title: 'Υπηρεσίες Κομμωτηρίου Χαλάνδρι – Χρώμα & Κούρεμα | Ikonomakis',
    description: 'Balayage, precision κούρεμα, bespoke χρώμα, κερατίνη, K18 και Face Metrics Pro AI στο Ikonomakis Hair Atelier Χαλάνδρι. Τιμές από €43 — κρατήσεις online.',
    image: DEFAULT_IMAGE,
    type: 'website',
  },
  '/heritage': {
    title: 'Ιστορία & Κληρονομιά – 30 Χρόνια Κομμωτικής | Ikonomakis',
    description: 'Η ιστορία του Ikonomakis Hair Atelier — 30+ χρόνια, 2η γενιά κομμωτών, αφοσίωση στην τέχνη του κουρέματος και χρώματος μαλλιών στο Χαλάνδρι, Αθήνα.',
    image: 'https://media.base44.com/images/public/69d96446735f4e1f0f7d5bbf/4db058940_generated_59866471.png',
    type: 'article',
  },
  '/atelier': {
    title: 'Το Atelier – Ιστορία & Ομάδα | Ikonomakis Hair Atelier',
    description: 'Ο Θοδωρής Οικονομάκης, ιδρυτής του Ikonomakis Hair Atelier, δημιούργησε το Face Metrics Pro & Kommosis AI. 30+ χρόνια, εκπαίδευση σε 19 χώρες.',
    image: DEFAULT_IMAGE,
    type: 'website',
  },
  '/atelier/team': {
    title: 'Η Ομάδα Κομμωτών Χαλάνδρι – Master Stylists | Ikonomakis',
    description: '7 ειδικοί κομμωτικής στο Χαλάνδρι: Master Stylists & Color Specialists. Επίλεξε τον ειδικό σου και κλείσε ραντεβού online.',
    image: DEFAULT_IMAGE,
    type: 'website',
  },
  '/atelier/impact': {
    title: 'Κοινωνική Δράση & Βιωσιμότητα | Ikonomakis Χαλάνδρι',
    description: 'Βιώσιμες πρακτικές, δωρεά μαλλιών και κοινωνική προσφορά από το Ikonomakis Hair Atelier στο Χαλάνδρι — το πρώτο green salon στη Βόρεια Αθήνα.',
    image: DEFAULT_IMAGE,
    type: 'article',
  },
  '/press': {
    title: 'Βραβεία & Δημοσιεύσεις – Τύπος | Ikonomakis Χαλάνδρι',
    description: 'Βραβεία καινοτομίας, δημοσιεύσεις και διακρίσεις του Ikonomakis Hair Atelier και του Θοδωρή Οικονομάκη στον χώρο της κομμωτικής και της AI τεχνολογίας.',
    image: DEFAULT_IMAGE,
    type: 'website',
  },
  '/innovations': {
    title: 'AI Καινοτομία – Face Metrics Pro | Ikonomakis Χαλάνδρι',
    description: 'Πρωτοποριακές τεχνολογίες κομμωτικής: Face Metrics Pro AI, Kommosis AI, διάγνωση τρίχας και bespoke συμβουλευτική στο Ikonomakis Hair Atelier Χαλάνδρι.',
    image: DEFAULT_IMAGE,
    type: 'article',
  },
  '/gallery': {
    title: 'Gallery – Balayage & Κουρέματα Χαλάνδρι | Ikonomakis',
    description: 'Δες πραγματικά αποτελέσματα από το Ikonomakis Hair Atelier: balayage, χρώμα, precision κουρέματα και hair transformations στο Χαλάνδρι.',
    image: DEFAULT_IMAGE,
    type: 'website',
  },
  '/journal': {
    title: 'Journal Κομμωτικής – Συμβουλές & Οδηγοί | Ikonomakis',
    description: 'Άρθρα, συμβουλές και care guides για balayage, χρώμα και περιποίηση μαλλιών από τους ειδικούς του Ikonomakis Hair Atelier Χαλάνδρι.',
    image: DEFAULT_IMAGE,
    type: 'website',
  },
  '/booking': {
    title: 'Κράτηση Online – Ραντεβού Χαλάνδρι | Ikonomakis Hair Atelier',
    description: 'Κλείσε ραντεβού online στο Ikonomakis Hair Atelier Χαλάνδρι. Επίλεξε tier ειδικού, υπηρεσία και ώρα — γρήγορα και εύκολα.',
    image: DEFAULT_IMAGE,
    type: 'website',
  },
  '/before-after': {
    title: 'Πριν & Μετά: Πραγματικές Μεταμορφώσεις Μαλλιών | Ikonomakis',
    description: 'Δες πραγματικά αποτελέσματα balayage, ξανθού, color correction & κουρέματος πριν και μετά. ★4,9 από 2.199 κριτικές. Κλείσε τη δική σου αλλαγή online.',
    image: DEFAULT_IMAGE,
    type: 'website',
  },
  '/team': {
    title: 'Η Ομάδα Κομμωτών Χαλάνδρι | Ikonomakis Hair Atelier',
    description: 'Master Hair Artists και Color Specialists με 30+ χρόνια εμπειρίας στο Ikonomakis Hair Atelier Χαλάνδρι. Γνωρίστε την ομάδα μας.',
    image: DEFAULT_IMAGE,
    type: 'website',
  },
  '/impact': {
    title: 'Κοινωνική Προσφορά & Δωρεά Μαλλιών | Ikonomakis Χαλάνδρι',
    description: 'Δωρεά μαλλιών, βιώσιμες πρακτικές και κοινωνική δράση. Το πρώτο green salon στο Χαλάνδρι — Ikonomakis Hair Atelier.',
    image: DEFAULT_IMAGE,
    type: 'article',
  },
  '/contact': {
    title: 'Κομμωτήριο Χαλάνδρι: Ωράριο & Ραντεβού | Ikonomakis',
    description: 'Ηρακλείτου 80, Χαλάνδρι · ☎ 211 800 4132. Τρ-Πε-Πα 10-20, Τε-Σα 9-17. ★4,9 από 2.199 κριτικές. Κλείσε ραντεβού online σε 60″, εύκολο parking.',
    image: DEFAULT_IMAGE,
    type: 'website',
  },
  '/balayage': {
    title: 'Balayage στο Χαλάνδρι – Τιμές από €150 | Ikonomakis',
    description: 'Balayage στο Χαλάνδρι από Master Color Specialists. Bespoke hand-painted χρώμα, all-inclusive εμπειρία με διάγνωση & styling. Τιμές από €150 — κρατήσεις online.',
    image: DEFAULT_IMAGE,
    type: 'website',
  },
  '/ai-axiologisi-mallion': {
    title: 'AI Ανάλυση Μαλλιών Χαλάνδρι – Πρώτη στην Ελλάδα | Ikonomakis',
    description: 'Η πρώτη AI αξιολόγηση μαλλιών στην Ελλάδα στο Ikonomakis Hair Atelier Χαλάνδρι. Επιστημονική ανάλυση τύπου, κατάστασης και αναγκών της τρίχας.',
    image: DEFAULT_IMAGE,
    type: 'website',
  },
  '/keratini': {
    title: 'Κερατίνη στο Χαλάνδρι – Τιμές & Αποτελέσματα | Ikonomakis',
    description: 'Βιολογική κερατίνη & ισιωτικές θεραπείες στο Χαλάνδρι. Qiqi Vega, Brazilian smoothing — all-inclusive εμπειρία στο Ikonomakis Hair Atelier.',
    image: DEFAULT_IMAGE,
    type: 'website',
  },
  '/koureima-ikonomakis': {
    title: 'Κούρεμα με Προσωπολογία Χαλάνδρι – Total Look | Ikonomakis',
    description: 'Εξατομικευμένο κούρεμα με προσωπολογία & σωματομετρία στο Χαλάνδρι. Face Metrics Pro, total look & hair transformation — Ikonomakis Hair Atelier.',
    image: DEFAULT_IMAGE,
    type: 'website',
  },
  '/hair-salon-chalandri': { title: 'Κομμωτήριο Χαλάνδρι – Bespoke Χρώμα & Κούρεμα | Ikonomakis', description: 'Premium κομμωτήριο στο Χαλάνδρι. Bespoke balayage, precision κούρεμα, AI ανάλυση προσώπου. Από τον Θοδωρή Οικονομάκη, 2η γενιά κομμωτή — κρατήσεις online.', image: DEFAULT_IMAGE, type: 'website' },
  '/premium-hair-salon-athens': { title: 'Premium Κομμωτήριο Αθήνα – Χαλάνδρι | Ikonomakis', description: 'Premium hair atelier στην Αθήνα (Χαλάνδρι). Precision κούρεμα, bespoke balayage, luxury θεραπείες και Face Metrics Pro AI — από τον Θοδωρή Οικονομάκη.', image: DEFAULT_IMAGE, type: 'website' },
  '/hair-salon-northern-suburbs-athens': { title: 'Κομμωτήριο Βόρεια Προάστια Αθήνας | Ikonomakis Χαλάνδρι', description: 'Premium κομμωτήριο στα Βόρεια Προάστια Αθήνας. Χαλάνδρι, Μαρούσι, Κηφισιά, Φιλοθέη, Ψυχικό. Bespoke υπηρεσίες, κρατήσεις online.', image: DEFAULT_IMAGE, type: 'website' },
  '/balayage-northern-suburbs': { title: 'Balayage Βόρεια Προάστια – Από €150 | Ikonomakis', description: 'Balayage στα Βόρεια Προάστια Αθήνας από Master Color Specialists. Premium hand-painted χρώμα, εξυπηρέτηση Μαρούσι, Κηφισιά, Φιλοθέη — Ikonomakis Χαλάνδρι.', image: DEFAULT_IMAGE, type: 'website' },
  '/babylights-chalandri': { title: 'Babylights στο Χαλάνδρι – Τιμές από €150 | Ikonomakis', description: 'Babylights στο Χαλάνδρι. Λεπτές, φυσικές ανταύγειες από Master Hair Artists. All-inclusive εμπειρία — τιμές από €150 στο Ikonomakis Hair Atelier.', image: DEFAULT_IMAGE, type: 'website' },
  '/tizzy-lights-chalandri': { title: 'Tizzy Lights Χαλάνδρι – Νέα Γενιά Ανταυγειών | Ikonomakis', description: 'Tizzy Lights στο Χαλάνδρι — multidimensional, φυσικό χρώμα νέας γενιάς. Master Hair Artists στο Ikonomakis Hair Atelier, κρατήσεις online.', image: DEFAULT_IMAGE, type: 'website' },
  '/color-correction-chalandri': { title: 'Color Correction Χαλάνδρι – Διόρθωση Χρώματος | Ikonomakis', description: 'Color correction στο Χαλάνδρι. Διόρθωση αποτυχημένων χρωμάτων, ξάνοιγμα & αλλαγή απόχρωσης από Master Color Specialists — Ikonomakis Hair Atelier.', image: DEFAULT_IMAGE, type: 'website' },
  '/blonde-specialist-chalandri': { title: 'Blonde Specialist Χαλάνδρι – Ξανθά από €150 | Ikonomakis', description: 'Blonde specialist στο Χαλάνδρι. Platinum, beige & scandinavian blonde από Master Hair Artists — τιμές από €150, Ikonomakis Hair Atelier.', image: DEFAULT_IMAGE, type: 'website' },
  '/hair-color-chalandri': { title: 'Χρώμα Μαλλιών στο Χαλάνδρι – Τιμές από €43 | Ikonomakis', description: 'Premium βαφή & χρώμα μαλλιών στο Χαλάνδρι. All-inclusive εμπειρία με διάγνωση & διαφανείς τιμές από €43 — Ikonomakis Hair Atelier, κρατήσεις online.', image: DEFAULT_IMAGE, type: 'website' },
  '/precision-haircut-chalandri': { title: 'Precision Κούρεμα Χαλάνδρι – Από €45 | Ikonomakis', description: 'Precision haircut στο Χαλάνδρι με προσωπομετρία & προσωπολογία (visagisme). Total look, εξατομικευμένο αποτέλεσμα — τιμές από €45, Ikonomakis Hair Atelier.', image: DEFAULT_IMAGE, type: 'website' },
  '/womens-haircut-chalandri': { title: 'Γυναικείο Κούρεμα Χαλάνδρι – Τιμές από €45 | Ikonomakis', description: 'Γυναικείο κούρεμα στο Χαλάνδρι με ανάλυση προσωπολογίας. Editorial cuts από Master Hair Artists — τιμές από €45, Βόρεια Προάστια Αθήνας.', image: DEFAULT_IMAGE, type: 'website' },
  '/keratin-treatment-chalandri': { title: 'Κερατίνη στο Χαλάνδρι – Τιμές από €150 | Ikonomakis', description: 'Βιολογική κερατίνη στο Χαλάνδρι. Qiqi Vega & Brazilian smoothing για υγιή, πειθαρχημένα μαλλιά — all-inclusive, τιμές από €150.', image: DEFAULT_IMAGE, type: 'website' },
  '/hair-botox-chalandri': { title: 'Hair Botox στο Χαλάνδρι – Αναδόμηση Μαλλιών | Ikonomakis', description: 'Hair botox στο Χαλάνδρι. Εντατική αναδόμηση & λάμψη χωρίς formaldehyde. Premium θεραπεία στο Ikonomakis Hair Atelier, Βόρεια Προάστια.', image: DEFAULT_IMAGE, type: 'website' },
  '/k18-hair-treatment-chalandri': { title: 'K18 Treatment στο Χαλάνδρι – Τιμές από €45 | Ikonomakis', description: 'K18 hair treatment στο Χαλάνδρι. Molecular αποκατάσταση τρίχας σε επίπεδο πεπτιδίου — τιμές από €45, Ikonomakis Hair Atelier.', image: DEFAULT_IMAGE, type: 'website' },
  '/face-metrics-pro-experience': { title: 'Face Metrics Pro – Ανάλυση Προσώπου | Θοδωρής Οικονομάκης', description: 'Μορφολογική ανάλυση προσώπου από τον Θοδωρή Οικονομάκη. Προτάσεις κουρέματος και χρώματος βάσει αναλογιών και συμμετρίας. €100 · 45 λεπτά στο Χαλάνδρι.', image: DEFAULT_IMAGE, type: 'website', canonical: `${SITE_URL}/services/face-metrics-pro` },
  '/face-metrics-pro': { title: 'Face Metrics Pro – Μορφολογική Ανάλυση €100 | Ikonomakis', description: 'Μορφολογική ανάλυση προσώπου από τον Θοδωρή Οικονομάκη — €100 · 45 λεπτά στο atelier στο Χαλάνδρι.', image: DEFAULT_IMAGE, type: 'website', canonical: `${SITE_URL}/services/face-metrics-pro` },
  '/best-balayage-athens': { title: 'Balayage Αθήνα – Τιμές από €150 | Ikonomakis Hair Atelier', description: 'Balayage στην Αθήνα από Master Color Specialists. Hand-painted, bespoke χρώμα με all-inclusive εμπειρία στο Ikonomakis Hair Atelier Χαλάνδρι.', image: DEFAULT_IMAGE, type: 'website', canonical: `${SITE_URL}/balayage-athens` },
  '/premium-balayage-athens': { title: 'Premium Balayage Αθήνα – Bespoke Χρώμα | Ikonomakis', description: 'Premium balayage στην Αθήνα από Master Color Specialists. Bespoke hand-painted χρώμα, luxury εμπειρία — Ikonomakis Hair Atelier Χαλάνδρι.', image: DEFAULT_IMAGE, type: 'website', canonical: `${SITE_URL}/balayage-athens` },
  '/best-hair-salon-athens': { title: 'Καλύτερο Κομμωτήριο Αθήνα – Οδηγός Επιλογής | Ikonomakis', description: 'Τι κάνει ένα hair salon premium: consultation, τεχνική ακρίβεια, εξατομίκευση και all-inclusive εμπειρία. Editorial οδηγός από το Ikonomakis Hair Atelier.', image: DEFAULT_IMAGE, type: 'website' },
  '/premium-hair-salon-greece': { title: 'Premium Κομμωτήριο Ελλάδα | Ikonomakis Hair Atelier Αθήνα', description: 'Premium hair atelier στην Ελλάδα — Ikonomakis Χαλάνδρι. Precision κούρεμα, bespoke χρώμα, θεραπείες και Face Metrics Pro AI από τον Θοδωρή Οικονομάκη.', image: DEFAULT_IMAGE, type: 'website' },
  '/luxury-hair-atelier-greece': { title: 'Luxury Hair Atelier Ελλάδα – Bespoke Εμπειρία | Ikonomakis', description: 'Luxury hair atelier στην Ελλάδα: premium consultation, precision cutting, bespoke χρώμα, θεραπείες & AI hair consultation — Ikonomakis Hair Atelier.', image: DEFAULT_IMAGE, type: 'website' },
  '/hair-expert-greece': { title: 'Hair Expert Ελλάδα – Θοδωρής Οικονομάκης | Ikonomakis', description: 'Εξειδίκευση Θοδωρή Οικονομάκη: haircutting, hair color, balayage, face shape analysis, εκπαίδευση κομμωτών και hair technology — Ikonomakis Hair Atelier.', image: DEFAULT_IMAGE, type: 'profile' },
  '/ai-hair-consultation-greece': { title: 'Face Metrics Pro Ελλάδα – AI Ανάλυση Προσώπου | Ikonomakis', description: 'Μορφολογική ανάλυση προσώπου από τον Θοδωρή Οικονομάκη — πρώτη στην Ελλάδα. Γεωμετρία, αναλογίες, συμμετρία — €100 · 45 λεπτά στο atelier.', image: DEFAULT_IMAGE, type: 'website' },
  '/ai-hair-consultation-athens': { title: 'Face Metrics Pro Αθήνα – AI Ανάλυση Προσώπου | Ikonomakis', description: 'Μορφολογική ανάλυση προσώπου στο Ikonomakis Hair Atelier Χαλάνδρι. Τεκμηριωμένη καθοδήγηση κουρέματος & χρώματος — €100 · 45 λεπτά στο atelier.', image: DEFAULT_IMAGE, type: 'website' },
  '/haircut-based-on-face-shape': { title: 'Κούρεμα Βάσει Σχήματος Προσώπου – Face Metrics Pro', description: 'Πώς η γεωμετρία, οι αναλογίες και η μορφολογία του προσώπου οδηγούν σε τεκμηριωμένο κούρεμα — μέθοδος FaceMetrics Pro, Θοδωρής Οικονομάκης.', image: DEFAULT_IMAGE, type: 'website' },
  '/services/hair-color': { title: 'Χρώμα Μαλλιών Χαλάνδρι – Balayage & Βαφή | Ikonomakis', description: 'Balayage, babylights, tizzy lights, color correction και premium βαφή μαλλιών στο Ikonomakis Hair Atelier Χαλάνδρι — τιμές από €43.', image: DEFAULT_IMAGE, type: 'website' },
  '/services/haircuts': { title: 'Κούρεμα με Προσωπολογία Χαλάνδρι – Από €45 | Ikonomakis', description: 'Κούρεμα με προσωπομετρία & προσωπολογία (visagisme) στο Χαλάνδρι. Precision haircut, curly cut, total look — τιμές από €45, Ikonomakis Hair Atelier.', image: DEFAULT_IMAGE, type: 'website' },
  '/services/hair-treatments': { title: 'Θεραπείες Μαλλιών Χαλάνδρι – Κερατίνη & K18 | Ikonomakis', description: 'Advanced hair treatments στο Χαλάνδρι: κερατίνη, K18, hair botox και premium αναδόμηση μαλλιών — Ikonomakis Hair Atelier, κρατήσεις online.', image: DEFAULT_IMAGE, type: 'website' },
  '/prosopologia-visagisme': { title: 'Προσωπολογία (Visagisme) Χαλάνδρι | Ikonomakis', description: 'Προσωπολογία (visagisme) στο Χαλάνδρι: κούρεμα και χρώμα που εκφράζουν ποιος είστε, με ερμηνεία του προσώπου και μετρήσεις Face Metrics Pro.', image: DEFAULT_IMAGE, type: 'website' },
  '/services/face-metrics-pro': { title: 'Face Metrics Pro – Μορφολογική Ανάλυση €100 | Ikonomakis', description: 'Δομημένη μορφολογική ανάλυση προσώπου από τον Θοδωρή Οικονομάκη. Γεωμετρία, αναλογίες, συμμετρία — καθοδήγηση κουρέματος & χρώματος. €100 · 45 λεπτά.', image: DEFAULT_IMAGE, type: 'website' },
  '/faq': { title: 'Συχνές Ερωτήσεις – Balayage, Κούρεμα & AI | Ikonomakis', description: 'Απαντήσεις για balayage, χρώμα, κούρεμα, Face Metrics Pro και επίσκεψη στο Ikonomakis Hair Atelier Χαλάνδρι. Τιμές, ώρες λειτουργίας, κρατήσεις.', image: DEFAULT_IMAGE, type: 'website' },
  '/reviews': { title: 'Κριτικές 4.9/5 | Ikonomakis Hair Atelier', description: 'Κριτικές για το Ikonomakis Hair Atelier Χαλάνδρι: 4.9/5 από 2.199 πιστοποιημένες κριτικές για balayage, κούρεμα, θεραπείες και Face Metrics Pro.', image: DEFAULT_IMAGE, type: 'website' },
  '/kommotirio-chalandri': { title: 'Κομμωτήριο Χαλάνδρι — Ikonomakis | Ηρακλείτου 80', description: 'Κομμωτήριο στο Χαλάνδρι, Ηρακλείτου 80. Balayage από €150, κούρεμα από €45, AI ανάλυση Face Metrics Pro. 4.9/5 από 2.199 κριτικές. Ikonomakis.', image: DEFAULT_IMAGE, type: 'website' },
  '/andriki-permanant-chalandri': { title: 'Ανδρική Περμανάντ Χαλάνδρι – Τιμές από €70 | Ikonomakis', description: 'Ανδρική περμανάντ στο Χαλάνδρι: test strand, χαμηλή αμμωνία, φυσικός κυματισμός & όγκος. Από €70 στο Ikonomakis Hair Atelier.', image: DEFAULT_IMAGE, type: 'website' },
  '/milbon-360-chalandri': { title: 'Milbon 360° Χαλάνδρι – Ιαπωνική Θεραπεία | Ikonomakis', description: 'Milbon 360° Japanese treatment στο Χαλάνδρι. Νανοτεχνολογία, βαθιά αναδόμηση, όγκος & λάμψη — all-inclusive πρωτόκολλο. Τιμές από €195.', image: DEFAULT_IMAGE, type: 'website' },
  '/thodoris-ikonomakis-hair-expert': { title: 'Θοδωρής Οικονομάκης – Hair Expert & AI | Ikonomakis', description: 'Ο Θοδωρής Οικονομάκης δημιούργησε το AI Hair Diagnosis, Face Metrics Pro & Hair Community Greece. Master balayage expert με 30+ χρόνια εμπειρίας.', image: DEFAULT_IMAGE, type: 'profile' },
  // Utility pages — noindex
  '/privacy': { title: 'Πολιτική Απορρήτου | Ikonomakis Hair Atelier', description: 'Πολιτική απορρήτου και προστασίας προσωπικών δεδομένων του Ikonomakis Hair Atelier.', image: DEFAULT_IMAGE, type: 'website', noindex: true },
  '/cookies': { title: 'Πολιτική Cookies | Ikonomakis Hair Atelier', description: 'Πολιτική cookies του Ikonomakis Hair Atelier.', image: DEFAULT_IMAGE, type: 'website', noindex: true },
  '/thank-you': { title: 'Ευχαριστούμε! | Ikonomakis Hair Atelier', description: 'Ευχαριστούμε για την κράτησή σας στο Ikonomakis Hair Atelier.', image: DEFAULT_IMAGE, type: 'website', noindex: true },
  '/terms': { title: 'Όροι Χρήσης | Ikonomakis Hair Atelier', description: 'Όροι χρήσης του Ikonomakis Hair Atelier.', image: DEFAULT_IMAGE, type: 'website', noindex: true },
  '/politiki-akyrosis': { title: 'Πολιτική Ακύρωσης & Κρατήσεων | Ikonomakis Hair Atelier', description: 'Δωρεάν ακύρωση έως 12 ώρες πριν το ραντεβού. Πώς λειτουργούν οι κρατήσεις, οι ακυρώσεις και η μη εμφάνιση στο Ikonomakis Hair Atelier.', image: DEFAULT_IMAGE, type: 'website', noindex: true },
};

const pageNames = {
  '/reviews': 'Κριτικές Πελατών',
  '/kommotirio-chalandri': 'Κομμωτήριο Χαλάνδρι',
  '/andriki-permanant-chalandri': 'Ανδρική Περμανάντ Χαλάνδρι',
  '/faq': 'Συχνές Ερωτήσεις',
  '/before-after': 'Before & After',
  '/journal': 'Journal',
  '/press': 'Press & Awards',
  '/gallery': 'Gallery',
  '/services/hair-color': 'Χρώμα Μαλλιών',
  '/services/haircuts': 'Κουρέματα',
  '/services/hair-treatments': 'Θεραπείες Μαλλιών',
  '/services/face-metrics-pro': 'Face Metrics Pro',
  '/services/airtouch': 'Airtouch',
  '/services/babylights': 'Babylights',
  '/milbon-360-chalandri': 'Milbon 360°',
  '/thodoris-ikonomakis-hair-expert': 'Θοδωρής Οικονομάκης',
  '/heritage': 'Heritage',
  '/atelier': 'Το Atelier',
  '/atelier/team': 'Η Ομάδα μας',
  '/atelier/impact': 'Atelier Impact',
  '/press': 'Press & Awards',
  '/services': 'Υπηρεσίες',
  '/innovations': 'Innovations',
  '/gallery': 'Gallery',
  '/journal': 'Άρθρα',
  '/booking': 'Κράτηση Online',
  '/before-after': 'Before & After',
  '/team': 'Η Ομάδα μας',
  '/impact': 'Social Impact',
  '/contact': 'Επικοινωνία',
  '/balayage': 'Balayage',
  '/ai-axiologisi-mallion': 'AI Αξιολόγηση Μαλλιών',
  '/keratini': 'Κερατίνη & Ισιωτικές Θεραπείες',
  '/koureima-ikonomakis': 'Κούρεμα Οικονομάκης',
  '/hair-salon-chalandri': 'Hair Salon Χαλάνδρι',
  '/premium-hair-salon-athens': 'Premium Hair Salon Αθήνα',
  '/hair-salon-northern-suburbs-athens': 'Hair Salon Βόρεια Προάστια',
  '/balayage-northern-suburbs': 'Balayage Βόρεια Προάστια',
  '/babylights-chalandri': 'Babylights Χαλάνδρι',
  '/tizzy-lights-chalandri': 'Tizzy Lights Χαλάνδρι',
  '/color-correction-chalandri': 'Color Correction Χαλάνδρι',
  '/blonde-specialist-chalandri': 'Blonde Specialist Χαλάνδρι',
  '/hair-color-chalandri': 'Hair Color Χαλάνδρι',
  '/precision-haircut-chalandri': 'Precision Haircut Χαλάνδρι',
  '/womens-haircut-chalandri': 'Γυναικείο Κούρεμα Χαλάνδρι',
  '/keratin-treatment-chalandri': 'Keratin Treatment Χαλάνδρι',
  '/hair-botox-chalandri': 'Hair Botox Χαλάνδρι',
  '/k18-hair-treatment-chalandri': 'K18 Treatment Χαλάνδρι',
  '/face-metrics-pro-experience': 'Face Metrics Pro Experience',
  '/premium-hair-salon-athens': 'Premium Hair Salon Athens',
  '/best-hair-salon-athens': 'Best Hair Salon Athens',
  '/premium-hair-salon-greece': 'Premium Hair Salon Greece',
  '/luxury-hair-atelier-greece': 'Luxury Hair Atelier Greece',
  '/thodoris-ikonomakis-hair-expert': 'Thodoris Ikonomakis Hair Expert',
  '/hair-expert-greece': 'Hair Expert Greece',
  '/ai-hair-consultation-greece': 'AI Hair Consultation Greece',
  '/ai-hair-consultation-athens': 'AI Hair Consultation Athens',
  '/haircut-based-on-face-shape': 'Haircut Based on Face Shape',
};

export const isAdminRoute = (pathname = '') => ADMIN_ROUTE_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));

// Bing/Google truncate descriptions > 160 chars: cut at the last word boundary before 157 and add "…"
export const clampDescription = (text) => {
  if (typeof text !== 'string' || text.length <= 160) return text;
  const cut = text.slice(0, 157);
  const lastSpace = cut.lastIndexOf(' ');
  return (lastSpace > 0 ? cut.slice(0, lastSpace) : cut).replace(/[\s,.;:—–-]+$/, '') + '…';
};

const DESCRIPTION_TAGS = ['meta[name="description"]', 'meta[property="og:description"]', 'meta[name="twitter:description"]'];

// Titles > 60 chars: shorten the brand suffix
export const enforceTitleLimit = () => {
  const t = document.title;
  if (t.length > 60 && t.includes(' | Ikonomakis Hair Atelier')) {
    document.title = t.replace(' | Ikonomakis Hair Atelier', ' | Ikonomakis');
  }
};

export const enforceDescriptionLimit = () => {
  DESCRIPTION_TAGS.forEach((sel) => {
    const tag = document.querySelector(sel);
    const content = tag?.getAttribute('content');
    const clamped = clampDescription(content);
    if (tag && clamped !== content) tag.setAttribute('content', clamped);
  });
};

// Sets description + og:description + twitter:description together
export const setPageDescription = (description) => {
  setMetaTag('description', description);
  setMetaTag('og:description', description, true);
  setMetaTag('twitter:description', description);
};

const setMetaTag = (name, content, useProperty = false) => {
  if (/description$/.test(name)) content = clampDescription(content);
  const selector = useProperty ? `meta[property="${name}"]` : `meta[name="${name}"]`;
  let tag = document.querySelector(selector);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(useProperty ? 'property' : 'name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};

const setLinkTag = (rel, href) => {
  let tag = document.querySelector(`link[rel="${rel}"]`);
  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', rel);
    document.head.appendChild(tag);
  }
  tag.setAttribute('href', href);
};

export const clearJsonLd = () => {
  document.querySelectorAll('script[data-seo-jsonld="true"]').forEach((node) => node.remove());
};

export const addJsonLd = (data) => {
  // One node per @id, page-wide. Pages and SEOHead both emit #salon; the static @graph in
  // index.html already carries it. Emitting it twice is what triggers Search Console's
  // "multiple aggregate ratings" / duplicate-entity warnings, so the first node wins.
  const id = data?.['@id'];
  if (id) {
    const exists = [...document.querySelectorAll('script[type="application/ld+json"]')].some((node) => {
      try {
        const parsed = JSON.parse(node.textContent);
        const nodes = parsed?.['@graph'] || [parsed];
        return nodes.some((n) => n?.['@id'] === id);
      } catch { return false; }
    });
    if (exists) return;
  }
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.setAttribute('data-seo-jsonld', 'true');
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
};

export const updateMetaTags = ({ title, description, image, url, type = 'website', noindex = false, canonical: overrideCanonical = null }) => {
  const resolvedImage = image || DEFAULT_IMAGE;
  document.title = title;
  setMetaTag('description', description);
  const keywordsTag = document.querySelector('meta[name="keywords"]');
  if (keywordsTag) keywordsTag.remove();
  setMetaTag('robots', noindex ? 'noindex, nofollow, noarchive' : 'index, follow, max-image-preview:large');
  setMetaTag('og:title', title, true);
  setMetaTag('og:description', description, true);
  setMetaTag('og:image', resolvedImage, true);
  setMetaTag('og:image:alt', image ? title : BUSINESS.ogImageAlt, true);
  // The static dimensions in index.html describe the default image only — stale numbers on a
  // per-page image make social/AI previews crop wrong, so drop them when the image changes.
  if (image && image !== DEFAULT_IMAGE) {
    document.querySelectorAll('meta[property="og:image:width"], meta[property="og:image:height"]').forEach((n) => n.remove());
  }
  setMetaTag('og:url', url, true);
  setMetaTag('og:type', type, true);
  setMetaTag('og:site_name', 'Ikonomakis Hair Atelier', true);
  setMetaTag('og:locale', new URL(url, SITE_URL).pathname.split('/')[1] === 'en' ? 'en_GB' : 'el_GR', true);
  setMetaTag('twitter:card', 'summary_large_image');
  setMetaTag('twitter:title', title);
  setMetaTag('twitter:description', description);
  setMetaTag('twitter:image', resolvedImage);
  setMetaTag('twitter:image:alt', image ? title : BUSINESS.ogImageAlt);
  setMetaTag('twitter:url', url);
  setLinkTag('canonical', overrideCanonical || url);
};

export const getCanonicalUrl = (pathname = '/') => pathname === '/' ? `${SITE_URL}/` : `${SITE_URL}${pathname}`;

export const getBreadcrumbSchema = (pathname) => {
  if (!pathname || pathname === '/' || isAdminRoute(pathname)) return null;

  // /services/* → 3-level breadcrumb
  if (pathname.startsWith('/services/') && pageNames[pathname]) {
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Αρχική', item: `${SITE_URL}/` },
        { '@type': 'ListItem', position: 2, name: 'Υπηρεσίες', item: `${SITE_URL}/services` },
        { '@type': 'ListItem', position: 3, name: pageNames[pathname], item: getCanonicalUrl(pathname) },
      ],
    };
  }

  // /atelier/* → 3-level breadcrumb
  if (pathname.startsWith('/atelier/') && pageNames[pathname]) {
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Αρχική', item: `${SITE_URL}/` },
        { '@type': 'ListItem', position: 2, name: 'Το Atelier', item: `${SITE_URL}/atelier` },
        { '@type': 'ListItem', position: 3, name: pageNames[pathname], item: getCanonicalUrl(pathname) },
      ],
    };
  }

  if (!pageNames[pathname]) return null;

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Αρχική', item: `${SITE_URL}/` },
      { '@type': 'ListItem', position: 2, name: pageNames[pathname], item: getCanonicalUrl(pathname) },
    ],
  };
};

// getSiteSchemas is intentionally empty — the canonical @graph schema
// is already embedded statically in index.html to avoid duplicate schemas.
export const getSiteSchemas = () => ([]);



// ─── Central HairSalon schema — injected on every public page via SEOHead ───
export const HAIRSALON_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'HairSalon',
  '@id': 'https://ikonomakis.gr/#salon',
  name: 'Ikonomakis Hair Atelier',
  description: `Ikonomakis Hair Atelier is a premium hair salon in Chalandri, Athens, with 30+ years of two-generation craftsmanship, a ${BUSINESS.reviews.rating}/5 rating from ${BUSINESS.reviews.displayEn} verified reviews, and the first salon in Greece offering AI facial analysis (Face Metrics Pro) for personalized hair color and cuts.`,
  url: 'https://ikonomakis.gr',
  telephone: '+30-211-800-4132',
  email: 'info@ikonomakis.gr',
  priceRange: '€€€',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Ηρακλείτου 80',
    addressLocality: 'Χαλάνδρι',
    addressRegion: 'Αττική',
    postalCode: '15238',
    addressCountry: 'GR',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: '38.0235',
    longitude: '23.8005',
  },
  openingHoursSpecification: [
    { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Tuesday', 'Thursday', 'Friday'], opens: '10:00', closes: '20:00' },
    { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Wednesday', 'Saturday'], opens: '09:00', closes: '17:00' },
  ],
  // No aggregateRating / review here: the same #salon node in index.html already carries
  // the verified rating and reviews. Two ratings on one item = "multiple aggregate ratings"
  // in Search Console and the review snippet is rejected.
  sameAs: [
    'https://www.fresha.com/a/ikonomakis-hair-atelier-halandri-irakleitoy-80-bxynmijf?pId=770996',
    'https://www.instagram.com/ikonomakishair/',
    'https://www.instagram.com/hair_atelier_by_ikonomakis/',
    'https://www.facebook.com/ikonomakishair',
    'https://maps.google.com/?q=Ηρακλείτου+80,+Χαλάνδρι',
  ],
};

// ─── Service schema builder — used per service hub page ───
export const buildServiceSchema = ({ name, description, priceFrom, url }) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  '@id': `${BUSINESS.siteUrl}${url}#service`,
  name,
  serviceType: name,
  description,
  url: `${BUSINESS.siteUrl}${url}`,
  provider: { '@id': 'https://ikonomakis.gr/#salon' },
  areaServed: [
    { '@type': 'City', name: 'Χαλάνδρι' },
    { '@type': 'City', name: 'Βριλήσσια' },
    { '@type': 'City', name: 'Μαρούσι' },
    { '@type': 'City', name: 'Αγία Παρασκευή' },
    { '@type': 'Neighborhood', name: 'Ψυχικό' },
    { '@type': 'City', name: 'Κηφισιά' },
    { '@type': 'Neighborhood', name: 'Φιλοθέη' },
  ],
  ...(priceFrom ? {
    offers: {
      '@type': 'Offer',
      url: BUSINESS.bookingUrl,
      priceCurrency: 'EUR',
      price: String(priceFrom),
      priceSpecification: {
        '@type': 'PriceSpecification',
        minPrice: String(priceFrom),
        priceCurrency: 'EUR',
      },
    },
  } : {}),
});

export const getHomeFaqSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  '@id': 'https://ikonomakis.gr/#faq',
  mainEntity: HOME_FAQ.map((f) => ({
    '@type': 'Question',
    name: f.question,
    acceptedAnswer: { '@type': 'Answer', text: f.answer },
  })),
});

export const getTeamPersonSchema = () => ({
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Person',
      name: 'Thodoris Ikonomakis',
      alternateName: 'Θοδωρής Οικονομάκης',
      jobTitle: 'Hair Expert, Founder of Hair Community Greece, Creator of Face Metrics Pro',
      worksFor: { '@id': 'https://ikonomakis.gr/#salon' },
      knowsAbout: ['Haircutting', 'Hair Color', 'Balayage', 'Face Shape Analysis', 'Προσωπολογία (Visagisme)', 'Visagism', 'Προσωπομετρία', 'Hair Consultation', 'Hair Education', 'Hair Technology'],
      description: 'Ο Θοδωρής Οικονομάκης είναι hair expert, ιδρυτής του Hair Community Greece και δημιουργός του Face Metrics Pro, με εκπαιδευτική, τεχνολογική και κομμωτική δράση στην Ελλάδα και το εξωτερικό.',
      sameAs: ['https://www.instagram.com/ikonomakis_hairexpert/', 'https://www.instagram.com/haircommunitygreece/']
    },
    {
      '@type': 'Person',
      name: 'Έλενα',
      jobTitle: 'Master Color Specialist',
      worksFor: { '@id': 'https://ikonomakis.gr/#salon' },
      knowsAbout: ['Bespoke Color', 'Balayage', 'Color Correction', 'Hand-painted Techniques'],
      description: 'Master Color Specialist στο atelier από το 2005, με εξειδίκευση σε bespoke color, balayage, color correction και hand-painted τεχνικές.'
    },
    {
      '@type': 'Person',
      name: 'Νίκος',
      jobTitle: 'Color Expert & Men’s Haircut Specialist',
      worksFor: { '@id': 'https://ikonomakis.gr/#salon' },
      knowsAbout: ['Bespoke Color', 'Color Techniques', 'Men’s Precision Cuts'],
      description: 'Color Expert με 10+ χρόνια εξειδίκευσης σε bespoke color techniques και ανδρικό κούρεμα ακριβείας.'
    },
    {
      '@type': 'Person',
      name: 'Ευγενία',
      jobTitle: 'Hair Expert',
      worksFor: { '@id': 'https://ikonomakis.gr/#salon' },
      knowsAbout: ['Women’s Haircut', 'Styling', 'Precision Cutting'],
      description: 'Hair Expert με 10+ χρόνια εμπειρίας, εξειδικευμένη στο γυναικείο κούρεμα και styling.'
    },
    {
      '@type': 'Person',
      name: 'Άννα',
      jobTitle: 'Hair Expert & Colorist',
      worksFor: { '@id': 'https://ikonomakis.gr/#salon' },
      knowsAbout: ['Haircut', 'Color Techniques', 'Bespoke Color'],
      description: 'Hair Expert & Colorist με διπλή εξειδίκευση σε κούρεμα και τεχνικές χρώματος.'
    },
    {
      '@type': 'Person',
      name: 'Ευανθία',
      jobTitle: 'Hairstylist & Colorist',
      worksFor: { '@id': 'https://ikonomakis.gr/#salon' },
      knowsAbout: ['Women’s Haircut', 'Styling', 'Color Techniques'],
      description: 'Hairstylist & Colorist, μέλος της ομάδας με all-inclusive premium προσέγγιση σε κούρεμα, styling και χρώμα.'
    },
    {
      '@type': 'Person',
      name: 'Γιολάντα',
      jobTitle: 'Hair Stylist',
      worksFor: { '@id': 'https://ikonomakis.gr/#salon' },
      knowsAbout: ['Women’s Haircut', 'Styling', 'Hair Consultation'],
      description: 'Hair Stylist με εξειδίκευση σε γυναικείο κούρεμα και styling, στο accessible premium tier του atelier.'
    }
  ]
});